// New file to define available operations per element type
export const OPERATIONS_BY_TYPE = {
  switch: [
    { label: 'Is', value: 'equals' },
    { label: 'Is not', value: 'not_equals' },
  ],
  number: [
    { label: 'Equals', value: 'equals' },
    { label: 'Does not equal', value: 'not_equals' },
    { label: 'Greater than', value: 'greater_than' },
    { label: 'Less than', value: 'less_than' },
  ],
  text: [
    { label: 'Equals', value: 'equals' },
    { label: 'Does not equal', value: 'not_equals' },
    { label: 'Contains', value: 'contains' },
    { label: 'Is empty', value: 'is_empty' },
    { label: 'Is not empty', value: 'is_not_empty' },
  ],
  hidden: [
    { label: 'Equals', value: 'equals' },
    { label: 'Does not equal', value: 'not_equals' },
    { label: 'Contains', value: 'contains' },
    { label: 'Is empty', value: 'is_empty' },
    { label: 'Is not empty', value: 'is_not_empty' },
  ],
  'single-choice': [
    { label: 'Is', value: 'equals' },
    { label: 'Is not', value: 'not_equals' },
  ],
  'multiple-choice': [
    { label: 'Contains', value: 'contains' },
    { label: 'Does not contain', value: 'not_contains' },
  ],
  kvk: [
    { label: 'Is selected', value: 'equals' },
    { label: 'Is not selected', value: 'not_equals' },
    { label: 'Contains', value: 'contains' },
  ],
  // Add other element types as needed
  default: [
    { label: 'Equals', value: 'equals' },
    { label: 'Does not equal', value: 'not_equals' },
    { label: 'Is empty', value: 'is_empty' },
    { label: 'Is not empty', value: 'is_not_empty' },
  ],
};
